import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonDateInput } from './DateInput.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonDateInput({ prefix }));
}
